import { client } from './ApolloClient'
import ErrorTrackingAPI from '../ErrorTrackingAPI'
import {
    CHECK_INVENTORY_STATUS,
    CHECK_ORDER_PAYMENT_STATUS,
    CREATE_ORDER,
    CREATE_MEMBER_ORDER,
    CREATE_PAYMENT_INTENT,
    AVAILABLE_PROMOS,
    RETRIEVE_ORDERS,
    RETRIEVE_ORDER_BY_NUMBER,
} from './schema'

const orderServices = {
    submitOrder: async input => {
        try {
            return client
                .mutate({
                    mutation: CREATE_ORDER,
                    variables: { input },
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.createOrder
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'submitOrder', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'submitOrder', 'SystemError')
            return { error }
        }
    },
    submitMemberOrder: async input => {
        try {
            return client
                .mutate({
                    mutation: CREATE_MEMBER_ORDER,
                    variables: { input },
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.createMemberOrder
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'submitMemberOrder', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'submitMemberOrder', 'SystemError')
            return { error }
        }
    },
    cancelProduct: async productId => {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(true)
            }, 3000)
        })
    },

    checkInventoryStatus: async ids => {
        try {
            return client
                .query({
                    query: CHECK_INVENTORY_STATUS,
                    variables: { ids },
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.checkInventoryStatus
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'checkInventoryStatus', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'checkInventoryStatus', 'SystemError')
            return { error }
        }
    },
    fetchAvailablePromos: async () => {
        try {
            return client
                .query({
                    query: AVAILABLE_PROMOS,
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.availablePromos
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchAvailablePromos', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchAvailablePromos', 'SystemError')
            return { error }
        }
    },

    fetchOrders: async input => {
        try {
            return client
                .query({
                    query: RETRIEVE_ORDERS,
                    variables: { input },
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.retrieveOrders
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchOrders', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchOrders', 'SystemError')
            return { error }
        }
    },

    fetchOrderByNumber: async input => {
        try {
            return client
                .query({
                    query: RETRIEVE_ORDER_BY_NUMBER,
                    variables: { input },
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.retrieveOrderByNumber
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchOrderByNumber', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'fetchOrderByNumber', 'SystemError')
            return { error }
        }
    },

    createPaymentIntent: async input => {
        try {
            return client
                .mutate({
                    mutation: CREATE_PAYMENT_INTENT,
                    variables: { input },
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.createPaymentIntent
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'createPaymentIntent', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'createPaymentIntent', 'SystemError')
            return { error }
        }
    },
    checkOrderPaymentStatus: async orderId => {
        try {
            return client
                .query({
                    query: CHECK_ORDER_PAYMENT_STATUS,
                    variables: { orderId },
                    fetchPolicy: 'network-only',
                })
                .then(res => {
                    return res.data.checkOrderPaymentStatus
                })
                .catch(error => {
                    ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'checkOrderPaymentStatus', 'GraphQLError')
                    return { error }
                })
        } catch (error) {
            ErrorTrackingAPI.sendError(error, 'GraphqlAPI', 'checkOrderPaymentStatus', 'SystemError')
            return { error }
        }
    },
}
export default orderServices
